
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/space/[spaceId]",
      function () {
        return require("private-next-pages/space/[spaceId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/space/[spaceId]"])
      });
    }
  